import { render } from "./Fotter.vue?vue&type=template&id=ebcf2b60&scoped=true"
import script from "./Fotter.vue?vue&type=script&lang=js"
export * from "./Fotter.vue?vue&type=script&lang=js"

import "./Fotter.vue?vue&type=style&index=0&id=ebcf2b60&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Tepparad\\Tepparad-benefit-newver\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebcf2b60"]])

export default __exports__